module.exports = __webpack_public_path__ + "img/circle_timer_icon.3fc3cc13.svg";